import { useTheme } from "context/ThemeContext/ThemeContext";

import { TAPE_SYMBOLS } from "../landingContent";
import { useTradingViewEmbed } from "../useTradingViewEmbed";

const WIDGET_SRC = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";

/**
 * Full-width market breadth marquee, driven by TradingView's Ticker Tape embed.
 *
 * Replaces the hand-rolled strip that shipped with the prototype: that one
 * scrolled a hardcoded price list, so the numbers were frozen at whatever the
 * design mock said.
 */
export function TickerTape() {
  const { theme } = useTheme();

  const { hostRef, status } = useTradingViewEmbed({
    src: WIDGET_SRC,
    config: {
      symbols: TAPE_SYMBOLS,
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: "adaptive",
      colorTheme: theme,
      locale: "en",
    },
  });

  return (
    <section
      id="markets"
      className="l-soft border-b"
      style={{ borderColor: "var(--line)" }}
      aria-label="Live market prices"
    >
      {/* The tape sets its own height once loaded; the reservation keeps the
          page from jumping when it does. */}
      <div className="l-tape-frame relative">
        {status === "loading" && (
          <div
            className="l-mono absolute inset-0 grid place-items-center text-11"
            style={{ letterSpacing: "0.08em", color: "var(--ink-subtle)" }}
          >
            LOADING MARKETS…
          </div>
        )}
        <div ref={hostRef} />
      </div>
    </section>
  );
}
